// @ts-nocheck
import React, { Component } from 'react';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';
import notification from 'antd/lib/notification';
import { monitoringPriceApi } from './../../lib/api';
import { goBack } from './../../lib/helpers';
import { Panel } from './../../components/layout';
import Header from './../../components/layout/Header';
import Breadcrumbs, { Crumb } from './../../components/layout/Breadcrumbs';
import { notificationLoading } from './../../components/Notifications';
import InnerForm from './components/InnerForm';
const StyledPanel = styled(Panel).withConfig({
  displayName: "MonitoringPriceForm__StyledPanel",
  componentId: "sc-st85zu-0"
})(["padding-top:0;"]);
class MonitoringPriceForm extends Component {
  state = {
    monitoringPrice: null
  };
  async componentDidMount() {
    let id = parseInt(this.props.id, 10);
    if (id) {
      try {
        const wash = await monitoringPriceApi.getMonitoringPrice(id);
        this.setState({
          monitoringPrice: wash
        });
      } catch (error) {
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
  }
  onSubmit = async values => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (this.props.id) {
        await monitoringPriceApi.updateMonitoringPrice(values);
      } else {
        await monitoringPriceApi.addMonitoringPrice(values);
      }
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate('/admin/monitoring-price');
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };
  onCancel = () => goBack('/admin/monitoring-price');
  render() {
    const {
      monitoringPrice
    } = this.state;
    const {
      id
    } = this.props;
    return <>
        <Header left={<Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/monitoring-price">
                Список прайсов мониторинга
              </Crumb>
              {id ? <Crumb to={`/admin/monitoring-price/${id}`}>
                  Прайс мониторинга №{id}
                </Crumb> : <Crumb to={`/admin/monitoring-price/new`}>
                  Новый прайс для мониторинга
                </Crumb>}
            </Breadcrumbs>} />
        <StyledPanel>
          <h1>
            {id ? `Прайс мониторинга №${id}` : `Новый прайс для мониторинга`}
          </h1>
        </StyledPanel>
        <InnerForm monitoringPrice={monitoringPrice} onSubmit={this.onSubmit} onCancel={this.onCancel} />
      </>;
  }
}
export default MonitoringPriceForm;
